export const houseInfoFieldsNames = {
  name: 'name',
  type: 'type',
  constructionYear: 'buildingDate',
  commissioningYear: 'commissioningDate',
  numberOfEntrances: 'entranceCount',
  numberOfFloors: 'floorCount',
  numberOfRooms: 'premisesCount',
  numberOfLivingRooms: 'flatCount',
  numberOfNonLivingRooms: 'officeCount',
  totalArea: 'totalArea',
  livingArea: 'flatArea',
  nonLivingArea: 'officeArea',
  numberOfElevators: 'elevatorCount',
  numberOfFreightElevators: 'serviceElevatorCount',
  numberOfpassengerElevators: 'passengerElevatorCount',
  comment: 'comment',
};
